import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import PaginationURL from "util/PaginationURL";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
export const urlPrefix = "/plugins/org.graylog.plugins.searchfilters";
export const USER_FILTER_QUERY_KEY = "user_filter_query_key";
export const DEFAULT_PAGINATION = {
  per_page: 25,
  page: 1,
  count: 0,
  total: 0
};
const fetchUserFilters = async ({
  query,
  page,
  per_page,
  scope,
  only_mutable
}) => {
  const url = PaginationURL(`${urlPrefix}/search_filters/paginated`, page, per_page, query, { scope, only_mutable });
  return fetch("GET", qualifyUrl(url));
};
const useUserSearchFiltersQuery = (requestQuery) => useQuery({
  queryKey: [USER_FILTER_QUERY_KEY, requestQuery],
  queryFn: () => defaultOnError(
    fetchUserFilters(requestQuery),
    i18n.t("notifications.load_filters_failed", { ns: "enterprise_search" }),
    i18n.t("notifications.load_filters_failed_title", { ns: "enterprise_search" })
  ),
  retry: 0,
  placeholderData: keepPreviousData,
  initialData: {
    filters: [],
    pagination: DEFAULT_PAGINATION
  }
});
export default useUserSearchFiltersQuery;
